module.exports = __webpack_public_path__ + "img/fire_yellow.128068ee.gif";